<template>
  <el-dialog title="诚意金账户详情" :visible.sync="dialogVisible" width="950px" :before-close="handleClose"  :close-on-click-modal="false">
    <div>
      <el-form label-width="210px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="上日诚意金余额：">
              {{detailData.beginBalance | keyFilter(detailData.beginBalance)}}
            </el-form-item>
            <el-form-item label="总计转出：">
              {{detailData.fundOutSum | keyFilter(detailData.fundOutSum)}}
            </el-form-item>
            <el-form-item label="软件使用费（挂牌）：">
              {{detailData.payFeeGP | keyFilter(detailData.payFeeGP)}}
            </el-form-item>
            <el-form-item label="本日诚意金余额：">
              {{detailData.currentBalance | keyFilter(detailData.currentBalance)}}
            </el-form-item>
            <el-form-item label="基本担保履约资金（订货）">
              {{detailData.lxExDepositBanlance | keyFilter(detailData.lxExDepositBanlance)}}
            </el-form-item>
            <el-form-item label="基本担保履约资金（到期）">
              {{detailData.lxDeDepositBanlance | keyFilter(detailData.lxDeDepositBanlance)}}
            </el-form-item>
            <el-form-item label="补充担保履约资金（订货）">
              {{detailData.lxOpenProfit | keyFilter(detailData.lxOpenProfit)}}
            </el-form-item>
            <el-form-item label="基本担保履约资金冻结（到期）">
              {{detailData.deliveryProfitDelistFreeze | keyFilter(detailData.deliveryProfitDelistFreeze)}}
            </el-form-item>
            <el-form-item label="冻结资金">
              {{detailData.forbidBalance | keyFilter(detailData.forbidBalance)}}
            </el-form-item>
            <el-form-item label="补充担保履约金（到期）">
              {{detailData.deliveryProfitDelist | keyFilter(detailData.deliveryProfitDelist)}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总计转入：">
              {{detailData.fundInSum | keyFilter(detailData.fundInSum)}}
            </el-form-item>
            <el-form-item label="软件使用费：">
              {{detailData.payFee | keyFilter(detailData.payFee)}}
            </el-form-item>
            <el-form-item label="预计当日补偿金：">
              {{detailData.predictDailyClaim | keyFilter(detailData.predictDailyClaim)}}
            </el-form-item>
            <el-form-item label="定单担保履约资金：">
              {{detailData.lxPreDepositBanlance | keyFilter(detailData.lxPreDepositBanlance)}}
            </el-form-item>
            <el-form-item label="基本担保履约资金（提前）：">
              {{detailData.lxDeDepositBalanceAdv | keyFilter(detailData.lxDeDepositBalanceAdv)}}
            </el-form-item>
            <el-form-item label="基本担保履约资金（挂牌）：">
              {{detailData.gpExDepositBanlance | keyFilter(detailData.gpExDepositBanlance)}}
            </el-form-item>
            <el-form-item label="补充担保履约金（提前）：">
              {{detailData.deliveryProfitAdvance | keyFilter(detailData.deliveryProfitAdvance)}}
            </el-form-item>
            <el-form-item label="可用金额：">
              {{detailData.canUseBalance | keyFilter(detailData.canUseBalance)}}
            </el-form-item>
            <el-form-item label="可预支诚意金：">
              {{detailData.canGetBalance | keyFilter(detailData.canGetBalance)}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="text-c m-t-20">
      <el-button size="small" @click="handleClose">返 回</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'cyj-detail',
  props: {
    detailData: {
      type: Object
    }
  },

  data () {
    return {
      detail: '',
      dialogData: {},
      dialogVisible: true
    }
  },
  filters: {
    // 金额保留两位小数
    keyFilter (v) {
      var f1 = parseFloat(v)
      if (isNaN(f1)) {
        return false
      }
      var f2 = Math.round(v * 100) / 100
      var s = f2.toString()
      var rs = s.indexOf('.')
      if (rs < 0) {
        rs = s.length
        s += '.'
      }
      while (s.length <= rs + 2) {
        s += '0'
      }
      return s + '元'
    }
  },
  mounted () {
  },
  methods: {
    handleClose () {
      this.$emit('done')
    }
  },
}
</script>

<style lang="scss" scoped>
.gobal-form{
  .el-input, .el-input__inner{
    width:217px !important;
  }
  div.input-val{
    display:inline-block;
    width:217px;
  }
}
</style>
